import router from '@/router'
import store from '@/store'
import getPageTitle from '@/utils/getPageTitle'
import {getToken} from '@/utils/auth'


router.beforeEach(async (to, from, next) => {
    if (getToken()) {
        if (to.path === '/login') {
            next({path: '/'})
        } else {
            next()
        }
    } else {
        if (to.matched.some(record => record.meta.Auth)) {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        } else {
            next() // 确保一定要调用 next()
        }
    }
})

router.afterEach((to) => {
    if (to.params.id) {
        setTimeout(() => {
            if (store.state.family.family.length > 0) {
                let data = store.state.family.family
                let fi = data.filter((el) => {
                    return el.id == to.params.id
                })
                document.title = getPageTitle(fi[0].name + to.meta.title)
            }
        }, 1000)

    } else {
        document.title = getPageTitle(to.meta.title)
    }

})
